export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/decor-vip.e1ae36c5-252061.svg";